import {Pattern, match} from 'ts-pattern';

import {ASSISTANT_INTEREST_TEXT_MAX_CHARACTERS} from '@prompt-bridge/shared/ai-assistant-core';

const WHITESPACE_RUN = /\s+/g;

export const toBoundedAssistantInterestText = (value: string | null | undefined) =>
  match(value)
    .returnType<string | undefined>()
    .with(Pattern.nullish, () => undefined)
    .otherwise((text) => {
      const normalized = text.replace(WHITESPACE_RUN, ' ').trim();
      return match(normalized)
        .with('', () => undefined)
        .otherwise((nonEmptyText) => nonEmptyText.slice(0, ASSISTANT_INTEREST_TEXT_MAX_CHARACTERS));
    });
